// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__9wfLK","input":"Input_input__xuWPx","label":"Input_label__vbmY2","error":"Input_error__9trOF"};